require("jquery-validation")

$.validator.addMethod("youtube", function(value, element) {
  var p = /^(?:https?:\/\/)?(?:m\.|www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
  if(value.length > 0){
  	return (value.match(p)) ? RegExp.$1 : false;
  }else{
  	return true;
  }
}, "Enter correct Youtube URL");